export var AwsRdsEngine;
(function (AwsRdsEngine) {
    AwsRdsEngine["AWS_RDS_ENGINE_UNSPECIFIED"] = "UNSPECIFIED";
    AwsRdsEngine["AWS_RDS_ENGINE_POSTGRES"] = "POSTGRES";
    AwsRdsEngine["AWS_RDS_ENGINE_MYSQL"] = "MYSQL";
    AwsRdsEngine["AWS_RDS_ENGINE_AURORA_MYSQL"] = "AURORA_MYSQL";
    AwsRdsEngine["AWS_RDS_ENGINE_AURORA_POSTGRESQL"] = "AURORA_POSTGRESQL";
    AwsRdsEngine["AWS_RDS_ENGINE_SQLSERVER_SE"] = "SQLSERVER_SE";
    AwsRdsEngine["AWS_RDS_ENGINE_SQLSERVER_EE"] = "SQLSERVER_EE";
    AwsRdsEngine["AWS_RDS_ENGINE_SQLSERVER_WEB"] = "SQLSERVER_WEB";
    AwsRdsEngine["AWS_RDS_ENGINE_SQLSERVER_EX"] = "SQLSERVER_EX";
    AwsRdsEngine["AWS_RDS_ENGINE_ORACLE_EE"] = "ORACLE_EE";
    AwsRdsEngine["AWS_RDS_ENGINE_ORACLE_EE_CDB"] = "ORACLE_EE_CDB";
    AwsRdsEngine["AWS_RDS_ENGINE_ORACLE_SE2"] = "ORACLE_SE2";
    AwsRdsEngine["AWS_RDS_ENGINE_ORACLE_SE2_CDB"] = "ORACLE_SE2_CDB";
    AwsRdsEngine["AWS_RDS_ENGINE_ORACLE_SE1"] = "ORACLE_SE1";
    AwsRdsEngine["AWS_RDS_ENGINE_ORACLE_SE"] = "ORACLE_SE";
})(AwsRdsEngine || (AwsRdsEngine = {}));
